import React, { useState, useRef, useEffect } from "react";
// app.js backup for web
import ACService from "./ACService";
import RepairGasRefill from "./RepairGasRefill";
import Installation from "./Installation";
import RateCard from "./RateCard";
import CartButton from "./CartButton";
import { CartProvider } from "./CartContext";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import MyBooking from "./MyBooking";
import CancellationPolicy from "./CancellationPolicy"; // 🔥 Import new page
import AboutSuperCoolPage from "./AboutSuperCoolPage";
import TechnicianDetails from "./TechnicianDetails";
import TechnicianDashboard from "./TechnicianDashboard"; 
import TechnicianLoginPage from "./TechnicianLoginPage";
import TechnicianAgreement from "./TechnicianAgreement"; // create this new component
import TechnicianLogin from './TechnicianLogin';
import History from "./History";
import HistoryBills from "./HistoryBills";
import MyEarnings from "./MyEarnings";
import MyRating from "./MyRating";
import MyRatingWrapper from "./MyRatingWrapper";
import { useLocation } from "react-router-dom";
import TechnicianRatings from "./TechnicianRatings";
import CustomerComplaintForm from "./CustomerComplaintForm";
import ViewComplaints from "./ViewComplaints";
import TechnicianComplaintView from "./TechnicianComplaintView";
import TechnicianIssue from "./TechnicianIssue"
import ViewMyIssues from "./ViewMyIssues"
import CustomerFeedback from "./CustomerFeedback";
import CustomerLogin from "./CustomerLogin";
import PrivacyPolicy from './PrivacyPolicy';
import ShareButton from "./ShareButton";
import AdminLogin from "./components/AdminLogin";
import Dashboard from "./components/Dashboard";
import TechnicianList from "./components/TechnicianList";
import TechnicianPayment from "./components/TechnicianPayment";
import Orders from "./components/Orders";
import ResolveTechnicianIssue from "./components/ResolveTechnicianIssue"; // adjust path if needed
import HandleCustomerComplaints from "./components/HandleCustomerComplaints";
import BulkOrderUploader from "./components/BulkOrderUploader";
import TechnicianRatingAverage from "./components/TechnicianRatingAverage"
import FullOrders from "./FullOrders";
import BackButtonHandler from "./BackButtonHandler";
import PaidReferralBy from "./PaidReferralBy";
import DeleteAccount from "./DeleteAccount";
import TechnicianHome from "./TechnicianHome";
import CustomerLogout from "./CustomerLogout";
import './App.css';

export default function App() {
  const [activeService, setActiveService] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const phone = localStorage.getItem("userPhone");
    setIsLoggedIn(!!phone); // true if logged in
  }, []);

  const editingBooking = location.state?.editingBooking;
  const menuRef = useRef();
  const buttonRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  
  // ✅ Your original return starts here:
  return (
    <CartProvider>
       <BackButtonHandler />
      <div style={{ position: "fixed", top: 20, left: 20, zIndex: 10000 }}>
        <button
          ref={buttonRef}
          onClick={() => setShowMenu(!showMenu)}
          style={{ fontSize: 24, background: "none", border: "none" }}
        >
          &#9776;
        </button>
      </div>

  <div
    ref={menuRef} // ✅ Menu div par bhi ref
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      height: "100vh",
      width: "45vw",
      backgroundColor: "white",
      zIndex: 9999,
      padding: 20,
      boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
      transform: showMenu ? "translateX(0%)" : "translateX(-100%)",
      transition: "transform 0.3s ease",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 20,
        marginTop: 60,
        alignItems: "center",
      }}
    >
      {/* Menu content goes here */}
            <Link to="/home" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>Book a service</button></Link>
            <Link to="/my-booking" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>My Bookings</button></Link>
            <Link to="/complaint" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>Help Center</button> </Link>
            <Link to="/historybills" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>History Bills</button></Link>
            <Link to="/customer-feedback" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>Customer Feedback</button></Link>
            <Link to="/about-coolfix" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
             <button style={menuButtonStyle}>About Coolfix</button>
            </Link>
            <Link to="/technician-login" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>Technician Login</button></Link>
            <Link to="/privacy-policy" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>📜 Privacy Policy</button></Link>
            <Link to="/share-button" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>📤 Share our app</button></Link>
            <Link to="/admin-login" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>🧑‍💼 For Office</button></Link>
            <Link to="/delete-account" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>🗑️ Delete My Account</button></Link>
            <Link to="/logout" style={{ textDecoration: "none", width: "100%" }} onClick={() => setShowMenu(false)}>
            <button style={menuButtonStyle}>Logout</button></Link>
            

          </div>
        </div>
        <Routes>
  {/* Default About Page */}
  <Route path="/" element={<AboutSuperCoolPage />} />

  {/* Home page alag route par (jaise /home) */}
  <Route
  path="/home"
  element={
    <div style={{height: "100vh", overflowY: "auto", WebkitOverflowScrolling: "touch", position: "relative"}}>
      <div
        style={{
          width: "100%",
          padding: "0",
          fontFamily: "Arial, sans-serif",
          boxSizing: "border-box",
          textAlign: "left",
          margin: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 15,
            margin: "80px 10px 30px",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => setActiveService("acservice")}
            style={getButtonStyle(activeService === "acservice")}
          >
            AC Service
          </button>
          <button
            onClick={() => setActiveService("repairgas")}
            style={getButtonStyle(activeService === "repairgas")}
          >
            Repair & Gas Refill
          </button>
          <button
            onClick={() => setActiveService("installation")}
            style={getButtonStyle(activeService === "installation")}
          >
            Installation/<br />Uninstallation
          </button>
          <button
            onClick={() => setActiveService("ratecard")}
            style={getButtonStyle(activeService === "ratecard")}
          >
            RateCard
          </button>
        </div>

        {activeService === "" && (
          <p style={{ textAlign: "center", color: "black", marginLeft: 45, marginBottom: 20 }}>
            Please click on a button to continue
          </p>
        )}

        {activeService === "acservice" && <ACService />}
        {activeService === "repairgas" && <RepairGasRefill />}
        {activeService === "installation" && <Installation />}
        {activeService === "ratecard" && <RateCard />}
      </div>

      <CartButton setActiveService={setActiveService} />
    </div>
  }
/>

          
          <Route path="/my-booking" element={<div><Link to="/" style={{ position: "fixed", top: 20, right: 20, zIndex: 10000, fontSize: 24 }}>
                  &#10005;</Link><MyBooking /></div>}/>
          {/* ✅ ADD THIS NEW ROUTE HERE 👇 */}
          <Route path="/cancel-booking" element={<CancellationPolicy />} />
          <Route path="/about-coolfix" element={<AboutSuperCoolPage />} />
          <Route path="/technician-details" element={<TechnicianDetails />} />
          <Route path="/technician-dashboard" element={<TechnicianDashboard />} />
          <Route path="/technician-login" element={ localStorage.getItem("technicianLoggedIn") === "true" ? (
          <Navigate to="/technician-home" />) : (<TechnicianLoginPage />)}/>
          <Route path="/technician-agreement" element={<TechnicianAgreement />} />
          <Route path="/technician-signin" element={<TechnicianLogin />} />
          <Route path="/historybills" element={<HistoryBills />} />
          <Route path="/history" element={<History />} />
          <Route path="/cart" element={<CartButton />} />
          <Route path="/my-earnings" element={<MyEarnings />} />
          <Route path="/my-rating" element={<MyRating />} />
          <Route path="/rate/:orderId" element={<MyRatingWrapper />} />
          <Route path="/technician-rating" element={<TechnicianRatings />} />
          <Route path="/complaint" element={<CustomerComplaintForm />} />
          <Route path="/view-complaints" element={<ViewComplaints />} />
          <Route path="/technician-complaints" element={<TechnicianComplaintView />} />
          <Route path="/technician-issue" element={<TechnicianIssue />} />
          <Route path="/view-my-issues" element={<ViewMyIssues />} />
          <Route path="/customer-feedback" element={<CustomerFeedback />} />
          <Route path="/customer-login" element={isLoggedIn ? <Navigate to="/" /> : <CustomerLogin />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />  
          <Route path="/share-button" element={<ShareButton />} /> 
          <Route path="/admin-login" element={localStorage.getItem("adminLoggedIn") === "true" ? (
          <Navigate to="/dashboard" />) : (<AdminLogin onLogin={() => localStorage.setItem("adminLoggedIn", "true")} />)}/>
          <Route path="/dashboard" element={localStorage.getItem("adminLoggedIn") === "true" ? 
          <Dashboard /> : <Navigate to="/admin-login" />} />
          <Route path="/technician-list" element={<TechnicianList />} />
          <Route path="/handle-customer-complaints" element={<HandleCustomerComplaints />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/upload-orders" element={<BulkOrderUploader />} />
          <Route path="/full-orders" element={<FullOrders />} />
          <Route path="/resolve-technician-issue" element={<ResolveTechnicianIssue />} />
          <Route path="/technician-payment" element={<TechnicianPayment />} />
          <Route path="/technician-rating-average" element={<TechnicianRatingAverage />} />
          <Route path="/paid-referral-by" element={<PaidReferralBy/>} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/technician-home" element={<TechnicianHome />} />
          <Route path="/logout" element={<CustomerLogout />} />
          <Route path="/customer-login" element={<CustomerLogin />} />

        </Routes>
    </CartProvider>
  );
}
console.log("✅ App component loaded");
function getButtonStyle(active) {
  return {
    padding: "10px 20px",
    backgroundColor: active ? "#007bff" : "#ddd",
    color: active ? "white" : "#333",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    fontWeight: active ? "bold" : "normal",

    // 👇👇 Add these lines
    width: "40%",            // Equal size
    height: "50px",         // Same height
    lineHeight: "1.4",       // Better line spacing
    whiteSpace: "normal",    // Allow line break
    textAlign: "center",     // Center text
    display: "flex",         // Center vertically & horizontally
    alignItems: "center",
    justifyContent: "center",
    textWrap: "wrap",        // For mobile wrapping
  };
}


const menuButtonStyle = {
  padding: "5px 5px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: 5,
  cursor: "pointer",
  width: "100%",
  textAlign: "center",
};
